<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" [classtype]="'bluehead'" mat-dialog-title>
</app-layout-dialogheader1>

<mat-dialog-content>
    <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
    <form [formGroup]="myform">
        <div class="container-fluid">
            <p class="form-hint">Fields with * are required</p>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="name">File</label>
                <div class="col-sm-9">
                     <app-file-chooser #layerfilecontrol [acceptFilter]="acceptFilter" [fileMessagePlaceholder]="fileMessagePlaceholder"
                        (fileSelectedEvent)="fileSelectedEventHandler($event)">   
                        <h6></h6>         
                    </app-file-chooser>
                    <div class="input-hint">{{hint}}</div>  
                </div>
            </div>
        </div>
    </form>
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
    <button mat-raised-button type="button" (click)="okaction()" [disabled]="!isvalid()"
        class="btn btn-success pull-right">Upload</button>
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>